import { render, staticRenderFns } from "./TeamSettings.vue?vue&type=template&id=2af75f4a&scoped=true&"
import script from "./TeamSettings.vue?vue&type=script&lang=js&"
export * from "./TeamSettings.vue?vue&type=script&lang=js&"
import style0 from "./TeamSettings.vue?vue&type=style&index=0&id=2af75f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af75f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af75f4a')) {
      api.createRecord('2af75f4a', component.options)
    } else {
      api.reload('2af75f4a', component.options)
    }
    module.hot.accept("./TeamSettings.vue?vue&type=template&id=2af75f4a&scoped=true&", function () {
      api.rerender('2af75f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/TeamSettings.vue"
export default component.exports